export default __webpack_public_path__ + "static/media/whatsapp-black.3ce52526.png";